// extracted by mini-css-extract-plugin
module.exports = {"loginContentRoot":"page_loginContentRoot__DT6c1","loadingImg":"page_loadingImg__LCidX","loading":"page_loading__4R6D5","desc":"page_desc__n0YTc"};